// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/member.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AcceptInviteLinkRequest, CancelInviteRequest, CreateInviteLinkRequest, GetAvailablePlansRequest, GetAvailablePlansResponse, GetBillingDetailsRequest, GetBillingDetailsResponse, GetMySubscriptionRequest, GetMySubscriptionResponse, GetMyUsageRequest, GetMyUsageResponse, InviteByEmailRequest, ListInviteLinksRequest, ListInviteLinksResponse, ListInvitesRequest, ListInvitesResponse, ListMembersRequest, ListMembersResponse, RemoveMemberRequest, RevokeInviteLinkRequest, UpdateBillingDetailsRequest, UpdateBillingDetailsResponse, UpdateMemberRoleRequest, UploadMemberAvatarRequest, WorkspaceInvite, WorkspaceInviteLink, WorkspaceMember } from "./member_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.MemberService
 */
export const MemberService = {
  typeName: "omnios.v1.MemberService",
  methods: {
    /**
     * Members
     *
     * @generated from rpc omnios.v1.MemberService.ListMembers
     */
    listMembers: {
      name: "ListMembers",
      I: ListMembersRequest,
      O: ListMembersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MemberService.UpdateMemberRole
     */
    updateMemberRole: {
      name: "UpdateMemberRole",
      I: UpdateMemberRoleRequest,
      O: WorkspaceMember,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MemberService.RemoveMember
     */
    removeMember: {
      name: "RemoveMember",
      I: RemoveMemberRequest,
      O: WorkspaceMember,
      kind: MethodKind.Unary,
    },
    /**
     * Email invites
     *
     * @generated from rpc omnios.v1.MemberService.InviteByEmail
     */
    inviteByEmail: {
      name: "InviteByEmail",
      I: InviteByEmailRequest,
      O: WorkspaceInvite,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MemberService.ListInvites
     */
    listInvites: {
      name: "ListInvites",
      I: ListInvitesRequest,
      O: ListInvitesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MemberService.CancelInvite
     */
    cancelInvite: {
      name: "CancelInvite",
      I: CancelInviteRequest,
      O: WorkspaceInvite,
      kind: MethodKind.Unary,
    },
    /**
     * Invite links
     *
     * @generated from rpc omnios.v1.MemberService.CreateInviteLink
     */
    createInviteLink: {
      name: "CreateInviteLink",
      I: CreateInviteLinkRequest,
      O: WorkspaceInviteLink,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MemberService.ListInviteLinks
     */
    listInviteLinks: {
      name: "ListInviteLinks",
      I: ListInviteLinksRequest,
      O: ListInviteLinksResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MemberService.RevokeInviteLink
     */
    revokeInviteLink: {
      name: "RevokeInviteLink",
      I: RevokeInviteLinkRequest,
      O: WorkspaceInviteLink,
      kind: MethodKind.Unary,
    },
    /**
     * Accept an invite link (called by the invited user)
     *
     * @generated from rpc omnios.v1.MemberService.AcceptInviteLink
     */
    acceptInviteLink: {
      name: "AcceptInviteLink",
      I: AcceptInviteLinkRequest,
      O: WorkspaceMember,
      kind: MethodKind.Unary,
    },
    /**
     * Avatar
     *
     * @generated from rpc omnios.v1.MemberService.UploadMemberAvatar
     */
    uploadMemberAvatar: {
      name: "UploadMemberAvatar",
      I: UploadMemberAvatarRequest,
      O: WorkspaceMember,
      kind: MethodKind.Unary,
    },
    /**
     * Billing (scoped to caller's workspace)
     *
     * @generated from rpc omnios.v1.MemberService.GetMySubscription
     */
    getMySubscription: {
      name: "GetMySubscription",
      I: GetMySubscriptionRequest,
      O: GetMySubscriptionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MemberService.GetMyUsage
     */
    getMyUsage: {
      name: "GetMyUsage",
      I: GetMyUsageRequest,
      O: GetMyUsageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MemberService.GetAvailablePlans
     */
    getAvailablePlans: {
      name: "GetAvailablePlans",
      I: GetAvailablePlansRequest,
      O: GetAvailablePlansResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MemberService.GetBillingDetails
     */
    getBillingDetails: {
      name: "GetBillingDetails",
      I: GetBillingDetailsRequest,
      O: GetBillingDetailsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MemberService.UpdateBillingDetails
     */
    updateBillingDetails: {
      name: "UpdateBillingDetails",
      I: UpdateBillingDetailsRequest,
      O: UpdateBillingDetailsResponse,
      kind: MethodKind.Unary,
    },
  }
};

